import { BatteryGuideContent } from './batteryGuideLayout'
import controllerImg1 from '@modul-connect/shared/img/controller1.png'
import controllerImg2 from '@modul-connect/shared/img/controller2.png'

export const ControllerBatteryGuide = () => (
  <BatteryGuideContent
    introText="Remove the old batteries and replace them with new as shown in the images. Make sure plus+ and minus- are placed in the correct way."
    batteryType="Type of battery:"
    batteryTypeText="2 x CR2032 3V Lithium batteries*"
    footnote="*Using the wrong battery type may damage the device or give inaccurate readings."
    image1={controllerImg1}
    caption1="Remove the old batteries."
    image2={controllerImg2}
    caption2="Insert new batteries. Make sure plus+ and minus- is placed in the correct way."
  />
)
